/* global globalThis */
import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "comfed-theme";

// Read the persisted theme (falls back to the OS preference, then "light").
const getInitialTheme = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch {
    // localStorage unavailable (private mode / SSR) — ignore.
  }
  if (globalThis.matchMedia?.("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }
  return "light";
};

const persist = (theme) => {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // ignore
  }
};

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    mode: getInitialTheme(),
  },
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === "dark" ? "light" : "dark";
      persist(state.mode);
    },
    setTheme: (state, action) => {
      state.mode = action.payload === "dark" ? "dark" : "light";
      persist(state.mode);
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
